/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
export const useKeyboardCallback = (passedKey, cb, deps = []) => {
    const keys = typeof passedKey === 'string' ? [passedKey] : passedKey;
    React.useEffect(() => {
        const handleKeyDown = (event) => {
            if (!keys.includes(event.key))
                return;
            cb(event.key);
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, deps);
};
